import axios from "axios";

// Function to fetch historical market data for a specific cryptocurrency
const coinMarketData = (id, days) => {
    // Creating a Promise to handle asynchronous fetching
    let promise = new Promise((resolve, reject) => {
        axios
            .get(
                `https://api.coingecko.com/api/v3/coins/${id}/market_chart?vs_currency=usd&days=${days}&interval=daily`,
                { crossDomain: true }
            )
            .then((res) => {
                // If the request is successful, resolve the Promise with the received data
                resolve(res.data);
            })
            .catch((err) => {
                // If there's an error, reject the Promise with the error details
                reject(err);
            });
    });

    // Returning the Promise
    return promise;
};

// Exporting the coinMarketData function
export default coinMarketData;
